import * as yup from 'yup'

export class VehicleCheckInPassengerAirbagPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInPassengerAirbagPhotoFile?: File = undefined
  vehicleCheckInHasPassengerAirbag?: boolean = undefined
}

export const vehicleCheckInPassengerAirbagPhotoValidationSchema = yup.object({
  vehicleCheckInPassengerAirbagPhotoFile: yup.mixed().nullable(),
  vehicleCheckInHasPassengerAirbag: yup.boolean().nullable()
})
